var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#DFEBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0786 5C17.2779 5 18.7343 5.32591 19.5454 6.20508C21.4396 6.54268 22.9585 8.81238 22.9585 11.4609C22.9585 13.1598 22.6635 14.5578 22.4858 15.249C22.6833 15.5875 22.8969 16.0894 22.897 16.6719C22.897 17.9891 22.24 18.8417 21.6265 19.2969C21.4527 20.9205 20.5379 21.9675 19.98 22.4639V24.0205C19.9806 24.9861 22.3279 26.3721 24.0005 27C24.2074 27.0776 24.4035 27.1641 24.5903 27.2578C25.2268 27.4712 25.8051 27.8106 26.2983 28.2441C23.5154 30.5872 19.9232 31.9999 16.0005 32C12.0776 32 8.48471 30.5874 5.70166 28.2441C5.79869 28.1589 5.89799 28.0757 6.00146 27.998C6.30475 27.7704 6.79879 27.4784 7.31006 27.2822C7.52913 27.1982 7.76025 27.1091 8.00049 27C8.07169 26.9677 8.14452 26.9348 8.21826 26.9014C9.89943 26.14 12.1777 25.1079 12.1782 24.0205V22.4746C11.5776 21.9652 10.5598 20.8702 10.3999 19.2236C9.91351 18.7595 9.10713 17.8129 9.10693 16.6416C9.10693 15.9303 9.38421 15.3559 9.62842 14.9912C9.47951 14.2286 9.19976 12.6324 9.19971 11.4609C9.19971 7.53639 11.9002 5.00006 16.0786 5Z",
    fill: "#9CBDFF"
  })));
}

export default SvgDefaultAvatar;